// Author YuJiaBei
// Date 2020-10-10 14:00:25

class SithMesMstShiftTeamUser {
constructor({
        id = null,
        mstShiftTeamId = '',
        admUserId = '',
        admUserIdLoginName = '',
        remark = ''}
= {}) {
    this.id = id;
    this.mstShiftTeamId = mstShiftTeamId;
    this.admUserId = admUserId;
    this.admUserIdLoginName = admUserIdLoginName;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesMstShiftTeamUser();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'mstShiftTeamId',
        label: 'label.sith.mst.sithMesMstShiftTeamUser.grid.mstShiftTeamId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'admUserIdLoginName',
        label: 'label.sith.mst.sithMesMstShiftTeamUser.grid.admUserIdLoginName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstShiftTeamUser.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        },
        {
        key: 'emAclDeptName',
        label: 'label.sith.mst.sithMesMstShiftTeamUser.grid.emAclDeptName',
        sortable: true,
        form: {
        type: 'input'
        }
        }
    ])}

const filter = {
    mstShiftTeamIdFilter : "",
    admUserIdFilter : "",
    admUserIdLoginNameFilter : "",
    emAclDeptIdFilter : "",
    emAclDeptNameFilter : "",
    emAclDeptNodeCodeFilter : "",
    emAclDeptNodeCodeNameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'mstShiftTeamIdFilter',
        label: 'label.sith.mst.sithMesMstShiftTeamUser.filter.mstShiftTeamId',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'admUserIdLoginNameFilter',
        label: 'label.sith.mst.sithMesMstShiftTeamUser.filter.admUserIdLoginName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
            ,fieldsBindingByEntityModalSelected: '{"admUserId":"id"}'
                }
        },
        {
        key: 'emAclDeptNameFilter',
        label: 'label.sith.mst.sithMesMstShiftTeamUser.filter.emAclDeptName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclDept'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"emAclDeptId":"id"}'
                }
        },
        {
        key: 'emAclDeptNodeCodeNameFilter',
        label: 'label.sith.mst.sithMesMstShiftTeamUser.filter.emAclDeptNodeCodeName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclDept'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"emAclDeptNodeCode":"nodeCode"}'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'mstShiftTeamId',
        label: 'label.sith.mst.sithMesMstShiftTeamUser.entity.mstShiftTeamId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'admUserIdLoginName',
        label: 'label.sith.mst.sithMesMstShiftTeamUser.entity.admUserIdLoginName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
            ,fieldsBindingByEntityModalSelected: '{"admUserId":"id"}'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstShiftTeamUser.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesMstShiftTeamUser, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
